import { Component, h } from 'preact';
import { TravelClass, WidgetTab } from '../../../common';
import { Modal, ModalBody, ModalHeader, ModalProps, ModalTitle } from '../../../modal';
import { Actions, actions, BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import TravelClassRadio from '../TravelClassRadio/TravelClassRadio';
import { FinText } from '../../../i18n';

const allTravelClasses: TravelClass[] = [
  TravelClass.MIXED,
  TravelClass.ECONOMY,
  TravelClass.PREMIUM_ECONOMY,
  TravelClass.BUSINESS,
];

export interface TravelClassModalProps extends ModalProps {}

interface StoreProps {
  travelClass: TravelClass;
  travelClasses: TravelClass[];
  currentTab: WidgetTab;
}

const mapStateToProps = ({
  selection: { travelClass },
  amState: { amSelection },
  ux: { travelClasses },
  currentTab,
}: BookingState): StoreProps => ({
  travelClass: currentTab === WidgetTab.AM ? amSelection.travelClass : travelClass,
  travelClasses: currentTab === WidgetTab.AM ? allTravelClasses : travelClasses,
  currentTab,
});

type EffectiveProps = TravelClassModalProps & StoreProps & WithStyles & Actions;

@withStyles()
@connectStore({ mapStateToProps, actions })
export default class TravelClassModal extends Component<TravelClassModalProps> {
  setTravelClass = (travelClass: TravelClass): void => {
    const { setTravelClass } = this.props as EffectiveProps;
    setTravelClass(travelClass);
  };

  get availableTravelClasses(): TravelClass[] {
    const { travelClasses } = this.props as EffectiveProps;
    return travelClasses;
  }

  render({ tx, travelClass }: EffectiveProps): h.JSX.Element {
    return (
      <Modal class="bw-travel-class-modal">
        <ModalHeader>
          <ModalTitle>
            <FinText id="travelClassModal.title" />
          </ModalTitle>
        </ModalHeader>
        <ModalBody class={tx('ps-large-x')}>
          {this.availableTravelClasses.map((t: TravelClass, i: number) => (
            <TravelClassRadio
              class={tx({ 'border-bottom': i !== this.availableTravelClasses.length - 1 })}
              key={t}
              value={t}
              checked={t === travelClass}
              onSelection={this.setTravelClass}
              enableCompactWidget={false}
            />
          ))}
        </ModalBody>
      </Modal>
    );
  }
}
